export const IS_VIEW_ALL_ROUTE = 'isViewAllRoute';
